import {
  CaseStudyQuestionType,
  QuestionDetailsRes,
  QuestionDetailType,
} from '@/types/question.type'
import { useClassStore } from '@/stores/useClassStore'
import SectionDrawer from '@/components/ui/section-drawer'
import { useGetQuestionDetail } from '../hooks/questionDetailsService'
import { getQuestionType } from '../utils'
import {
  CaseStudyQuestionDetail,
  ParagraphQuestionDetail,
} from './QuestionDetail'

const QuestionDrawer = ({
  questionId,
  setIsOpen,
  typeValue,
  fromChapterTable,
  onDeleteSuccess,
}: {
  fromChapterTable: boolean
  questionId: number
  title?: string
  setIsOpen: (isOpen: number) => void
  typeValue?: string
  onDeleteSuccess?: () => void
}) => {
  const { selectedClass } = useClassStore()

  const { questionDetail, isLoadingQuestionDetail, refetchQuestionDetail } =
    useGetQuestionDetail({
      questionId: questionId.toString(),
      questionType: typeValue || '',
      classId: fromChapterTable ? selectedClass?.class_id : null,
    })

  // Type guard to check if questionDetail is QuestionDetailType
  const isQuestionDetailType = (
    data: QuestionDetailsRes | undefined
  ): data is QuestionDetailType => {
    return data !== undefined && 'text' in data && 'moodle_question_id' in data
  }

  // Type guard to check if questionDetail is CaseStudyQuestionType
  const isCaseStudyQuestionType = (
    data: QuestionDetailsRes | undefined
  ): data is CaseStudyQuestionType => {
    return data !== undefined && 'case_study_id' in data && 'case_study' in data
  }

  const handleDeleteSuccess = () => {
    onDeleteSuccess?.()
    setIsOpen(0)
  }

  return (
    <SectionDrawer
      open={!!questionId}
      onClose={() => setIsOpen(0)}
      title={`Question Details`}
      direction='bottom'
      className='!rounded-[0px]'
    >
      <div className='h-full overflow-auto pb-6'>
        {isQuestionDetailType(questionDetail) ? (
          <ParagraphQuestionDetail
            fromClass={fromChapterTable}
            refetchQuestionDetail={() => refetchQuestionDetail?.()}
            questionDetail={questionDetail}
            isLoading={isLoadingQuestionDetail}
            questionType={getQuestionType(typeValue || '')}
            onDeleteSuccess={handleDeleteSuccess}
          />
        ) : isCaseStudyQuestionType(questionDetail) ? (
          <CaseStudyQuestionDetail
            fromClass={fromChapterTable}
            refetchQuestionDetail={() => refetchQuestionDetail?.()}
            questionDetail={questionDetail}
            isLoading={isLoadingQuestionDetail}
            questionType={getQuestionType(typeValue || '')}
            onDeleteSuccess={handleDeleteSuccess}
          />
        ) : null}
      </div>
    </SectionDrawer>
  )
}

export default QuestionDrawer
